// extracted by mini-css-extract-plugin
export default {"button":"in-z","reviewSort":"jn-z"};